import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../../../../../base/components/Button';
import { PasswordInput } from '../../../../../../base/components/Forms/PasswordInput';
import { useAppDispatch, useAppSelector, useRoutesWithLang } from '../../../../../../base/hooks';
import { __t } from '../../../../../../base/utils/t';
import { settingsActions } from '../../../redux/slice/settingsSlice';
import { SettingsRoutes } from '../../../routes';

import '../styles.scss';

export const SetNewPassword = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const {
        fields: { passwordNew },
        errors,
    } = useAppSelector((state) => state.recruiterAppSettings.changePassword);
    const settingsRoutes = useRoutesWithLang<typeof SettingsRoutes>(SettingsRoutes);

    const inputChangeHandler = (value: unknown) => {
        dispatch(settingsActions.setChangePasswordField({ id: 'passwordNew', value }));
    };

    const successCallback = () => navigate(settingsRoutes.Settings);

    const submitSetNewPasswordHandler = () => dispatch(settingsActions.changePasswordSubmit(successCallback));

    return (
        <div className='change-password'>
            <div className='change-password__form-item scroll-margin-for-fixed-header'>
                <p className='change-password__form-label'>{__t('Новый пароль')}</p>
                <PasswordInput
                    value={passwordNew}
                    placeholder={__t('Минимум 6 символов')}
                    onChange={inputChangeHandler}
                    errors={errors?.passwordNew}
                />
            </div>
            <Button className='change-password__button' onClick={submitSetNewPasswordHandler}>
                {__t('Сохранить')}
            </Button>
        </div>
    );
};
